import { render } from "./B2bPageRecadvsReceiveds.vue?vue&type=template&id=6c0fc87e&scoped=true&lang=pug"
import script from "./B2bPageRecadvsReceiveds.vue?vue&type=script&lang=js"
export * from "./B2bPageRecadvsReceiveds.vue?vue&type=script&lang=js"

import "./B2bPageRecadvsReceiveds.vue?vue&type=style&index=0&id=6c0fc87e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0fc87e"]])

export default __exports__